import React from 'react';
import {
  IonCard,
  IonCardContent,
  IonIcon,
  IonCol,
} from '@ionic/react';

export default function ActionButton(props) {
  return (
    <IonCol size="6">
      <IonCard color="medium" button={true} className="ion-text-center" onClick={props.onClick}>
        <IonCardContent>
          <IonIcon icon={props.icon} size="large" /><br />
          {props.label}
        </IonCardContent>
      </IonCard>
    </IonCol>   
  );
}